import styled from 'styled-components';

export const FiltersModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: ${({ $show }) => ($show ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  padding: 1rem;
`;

export const FiltersOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
`;

export const FiltersContent = styled.div`
  position: relative;
  background: ${({ theme }) => theme.colors.grey[900]};
  border-radius: 16px;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: rgba(0, 0, 0, 1);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const FiltersHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[800]};

  h3 {
    color: ${({ theme }) => theme.colors.grey.white};
  }

  .close-btn {
    background: transparent;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.grey[200]};
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s;

    &:hover {
      background: ${({ theme }) => theme.colors.grey[800]};
      color: ${({ theme }) => theme.colors.grey.white};
    }
  }
`;

export const ClearFiltersButton = styled.button`
  width: calc(100% - 3rem);
  margin: 1rem 1.5rem;
  padding: 0.75rem;
  background: #ff4444;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s;

  &:hover {
    background: #cc0000;
    transform: translateY(-1px);
  }
`;

export const FiltersBody = styled.div`
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.grey[800]};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.grey[600]};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.grey[500]};
  }
`;

export const FiltersRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 2rem;

  @media ${({ theme }) => theme.devices.mobile} {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const FiltersColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const VerticalDivider = styled.div`
  width: 1px;
  background: ${({ theme }) => theme.colors.grey[800]};

  @media ${({ theme }) => theme.devices.mobile} {
    display: none;
  }
`;

export const ValueFilterGroup = styled.div`
  padding: 1.5rem;
  background: ${({ theme }) => theme.colors.grey[800]};
  border-radius: 12px;
  margin-bottom: 2rem;
  border: 1px solid ${({ theme }) => theme.colors.grey[700]};

  > p {
    font-weight: 600;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.grey.white};
  }
`;

export const ValueInputs = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  > div {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    label {
      font-size: 0.875rem;
      color: ${({ theme }) => theme.colors.grey[300]};
      font-weight: 500;
    }

    input {
      padding: 0.75rem 1rem;
      border-radius: 8px;
      background: ${({ theme }) => theme.colors.grey[900]};
      border: 1px solid ${({ theme }) => theme.colors.grey[700]};
      color: ${({ theme }) => theme.colors.grey.black};
      font-size: 0.95rem;
      transition: all 0.2s;

      &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.primary.main};
        box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primary.main}20;
      }

      &::placeholder {
        color: ${({ theme }) => theme.colors.grey[500]};
      }
    }
  }

  @media ${({ theme }) => theme.devices.mobile} {
    grid-template-columns: 1fr;
  }
`;
